<template>
  <div v-if="table" :id="table.id" class="product-table">
    <h2 v-if="table.title">{{ table.title }}</h2>

    <table class="table is-narrow">
      <thead>
      </thead>
      <tbody>
      <tr v-for="(row, rowIndex) in table.config" :style="rowIndex % 2 === 0 ? 'background-color: #F8F8F8':''"
          class="field">
        <template v-if="row.decorator !== 'separator'">
          <td style="font-weight: bold" v-html="row.label"></td>

          <!--          <tablefield-->
          <!--            v-for="cell in table.data"-->
          <!--            :key="cell.dq + '-' + row.path"-->
          <!--            :column="row"-->
          <!--            :product="cell"-->
          <!--          ></tablefield>-->
          <!--          <component-->
          <!--            :is="'tablefield-' + row.decorator"-->
          <!--            :data="_.get(cell, row.path, '')"-->
          <!--            :config="row"-->
          <!--            :product="cell">-->
          <!--          </component>-->
          <tablefield
            v-for="(cell, cellIndex) in table.data"
            :key="rowIndex + '-' + '-' + cellIndex"
            :column="row"
            :product="cell"
            :secondary-index="0"
            :singleLine="true"

          ></tablefield>
        </template>
        <template v-else>
          <td :colspan="table.data.length + 1" style="font-weight: bold;background-color: #F8F8F8"
              v-html="row.label"></td>

        </template>
      </tr>
      </tbody>
    </table>
    <div class="fineprint table-time">{{ time }}</div>

  </div>
</template>

<script>
import FieldMixin from "../table-field/FieldMixin"
import {Table} from "../../model/table/Table"
import Tablefield from "../table-field/FieldContainer.vue";

export default {
  name: 'table-whitelabel',
  components: {Tablefield},
  mixins: [FieldMixin],
  props: {
    table: {
      required: true,
      type: Table
    }
  },
  created() {
    this.table.config = this.table.config.map(el => {
      if (el.decorator === 'composite') {
        el.singleLine = true
      }
      return el
    })
  },
  computed: {
    time() {
      return this.moment().format('[Stand:] DD. MMMM YYYY, HH:mm [Uhr]')
    }
  },
}
</script>



// WEBPACK FOOTER //
// TableWhitelabel.vue?181308ec